import { useLocation, useNavigate } from 'react-router-dom';
import {
    ACTIVITY_LOG_PATH,
    ALERT_LOG_PATH,
    DASHBOARD_PATH,
    DEVICES_PATH,
    EMERGENCY_ALERT_PATH,
    TAG_MANAGEMENT_PATH,
    USERS_PATH,
} from '../../router/RouteConstants';
import styles from './SideMenu.module.css';
import { useIntl } from 'react-intl';
import { useContext, useEffect } from 'react';
import { Context } from '../../context/Context';
import DashboardIcon from '../../assets/images/dashboard_Icon.png';
import UsersIcon from '../../assets/images/users_icon.png';
import DevicesIcon from '../../assets/images/devices_icon.png';
import ActivityLogIcon from '../../assets/images/activity_log_icon.png';
import DashboardLightIcon from '../../assets/images/dashboard_light_icon.svg';
import UserLightIcon from '../../assets/images/users_light_icon.svg';
import DevicesLightIcon from '../../assets/images/devices_light_icon.svg';
import ActivityLogLightIcon from '../../assets/images/activity_log_light_icon.svg';
import EmergencyAlertIcon from '../../assets/images/alert.svg';
import EmergencyAlertLightIcon from '../../assets/images/alert_light.svg';
import TagIcon from '../../assets/images/tag.svg';
import TagLightIcon from '../../assets/images/tag_light.svg';

const SideMenu = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const navigate = useNavigate();
    const location = useLocation();

    const {
        sideMenuCurrentActive,
        setSideMenuCurrentActive,
        triggerRefresh,
        isSideMenuOpen,
        setIsSideMenuOpen,
    } = useContext(Context);

    const sideMenu = [
        {
            idx: 0,
            header: f({ id: 'AI_EDU_DASHBOARD' }),
            key: 'dashboard',
            link: DASHBOARD_PATH,
            match: (p) => p === DASHBOARD_PATH,
            imageSrc: DashboardIcon,
            imageLight: DashboardLightIcon,
        },
        {
            idx: 1,
            header: f({ id: 'AI_EDU_USERS' }),
            key: 'user',
            link: USERS_PATH,
            match: (p) => p === USERS_PATH,
            imageSrc: UsersIcon,
            imageLight: UserLightIcon,
        },
        {
            idx: 2,
            header: f({ id: 'AI_EDU_DEVICES' }),
            key: 'device',
            link: DEVICES_PATH,
            match: (p) => p === DEVICES_PATH,
            imageSrc: DevicesIcon,
            imageLight: DevicesLightIcon,
        },
        {
            idx: 3,
            header: f({ id: 'AI_EDU_ACTIVITY_LOG' }),
            key: 'activity',
            link: ACTIVITY_LOG_PATH,
            match: (p) => p === ACTIVITY_LOG_PATH,
            imageSrc: ActivityLogIcon,
            imageLight: ActivityLogLightIcon,
        },
        {
            idx: 4,
            header: f({ id: 'AI_EDU_EMERGENCY_ALERT' }),
            link: EMERGENCY_ALERT_PATH,
            key: 'alert',
            match: (p) => p.startsWith(EMERGENCY_ALERT_PATH),
            imageSrc: EmergencyAlertIcon,
            imageLight: EmergencyAlertLightIcon,
        },
        {
            idx: 5,
            header: f({ id: 'AI_EDU_TAG_MANAGEMENT' }),
            link: TAG_MANAGEMENT_PATH,
            key: 'tag',
            match: (p) => p.startsWith(TAG_MANAGEMENT_PATH),
            imageSrc: TagIcon,
            imageLight: TagLightIcon,
        },
        {
            idx: 6,
            header: f({ id: 'AI_EDU_ALERT_LOG' }),
            link: ALERT_LOG_PATH,
            key: 'alertLog',
            match: (p) => p === ALERT_LOG_PATH,
            imageSrc: ActivityLogIcon,
            imageLight: ActivityLogLightIcon,
        },
    ];
    useEffect(() => {
        const item = sideMenu.find((i) => i.match(location.pathname));
        setSideMenuCurrentActive(item?.idx || 0);
    }, [location.pathname]);

    const handleSideMenuItemClick = (key, link) => {
        triggerRefresh(key);
        navigate(link);
        // Close side menu on mobile/zoomed view after navigation
        if (window.innerWidth <= 1080) {
            setIsSideMenuOpen(false);
        }
    };

    const handleOverlayClick = () => {
        setIsSideMenuOpen(false);
    };

    return (
        <>
            {/* Overlay for mobile menu */}
            {isSideMenuOpen && (
                <div className={styles.overlay} onClick={handleOverlayClick} />
            )}
            <div className={`${styles.side_panel} ${isSideMenuOpen ? styles.open : ''}`}>
                {sideMenu.map((item) => (
                    <div
                        className={`${styles.side_panel_item}  ${
                            sideMenuCurrentActive === item.idx
                                ? `${styles.active_side_bar}`
                                : ''
                        }`}
                        onClick={() => handleSideMenuItemClick(item.key, item.link)}
                        key={item.idx}
                    >
                        <span className={styles.item_icon}>
                            <img
                                src={
                                    sideMenuCurrentActive === item.idx
                                        ? item.imageLight
                                        : item.imageSrc
                                }
                            />
                        </span>
                        <span>{item.header}</span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default SideMenu;
